import { useCallback } from "react";

import { useSocketStore } from "./connection-store";
import { useChatStore } from "./use-chat-store";
import { connect, getOnMessageHandler } from "./utils";

import { Logger } from "utils/logger";

const useSendMessage = (): ((messageToSend: string) => boolean) => {
  const { setMessages, setIsLoading, setError, setPrompt } = useChatStore();
  const { setSocket, socket } = useSocketStore();

  const sendMessage = useCallback(
    (messageToSend: string): boolean => {
      if (socket === null || socket.readyState !== WebSocket.OPEN) {
        const onMessage = getOnMessageHandler({
          setError,
          setIsLoading,
          setMessages,
          setPrompt,
        });

        const { socketRef } = connect({
          messageToSend,
          onMessage,
          setError,
        });

        setSocket(socketRef);

        return socketRef.readyState === WebSocket.OPEN;
      }

      try {
        socket.send(messageToSend);

        return true;
      } catch (error) {
        Logger.error("Error sending message", {
          error,
          messageToSend,
        });

        return false;
      }
    },
    [socket, setSocket, setMessages, setIsLoading, setError, setPrompt],
  );

  return sendMessage;
};

export { useSendMessage };
